<template>
  <div class="sub-toolbar">
    <project-toolbar :selectMonth="false">
      <md-menu
        v-if="canDownload"
        md-align-trigger
        md-size="small"
        style="border-left: none"
      >
        <md-button md-menu-trigger>{{ L('download') }}</md-button>
        <md-menu-content>
          <md-menu-item @click="download('xlsx')">XLSX</md-menu-item>
          <md-menu-item @click="download('csv')">CSV</md-menu-item>
        </md-menu-content>
      </md-menu>
      <!-- Tag Categories 숨김 스위치 -->
      <span v-if="$config.feature.tags" class="box-left-edge">
        <md-checkbox
          style="font-weight: 500; width: 140px"
          v-model="isTagsShow"
          class="md-primary"
          :disabled="!disabled"
          >{{ L('showTag') }}</md-checkbox
        >
      </span>
      <!--Preset Menu-->
      <md-menu md-align-trigger md-size="small">
        <md-button md-menu-trigger :disabled="!disabled">
          {{ L('preset') }}
          <!-- 설정 -->
          <span v-if="selectedPreset" class="text-transform"
            >: {{ selectedPreset.name }}</span
          >
        </md-button>
        <md-menu-content>
          <md-menu-item
            :class="'presetList'"
            v-if="selectedPreset"
            @click="save()"
            >{{ L('save') }} : {{ selectedPreset.name }}</md-menu-item
          >
          <!-- 저장: -->

          <md-menu-item
            :class="'presetList'"
            v-if="selectedPreset"
            @click="resetPreset()"
            >{{ L('clearPreset') }} : {{ selectedPreset.name }}</md-menu-item
          >
          <!-- 해제: -->

          <md-menu-item
            :class="'presetList'"
            v-if="selectedPreset"
            @click="openRemove()"
            >{{ L('remove') }} : {{ selectedPreset.name }}</md-menu-item
          >
          <!-- 삭제: -->

          <md-menu-item :class="'presetList'" @click="openSaveAs()">
            {{ L('saveAs') }}...
            <!-- 추가 -->
          </md-menu-item>
          <md-divider></md-divider>
          <md-menu-item :class="'presetList'" v-if="presets.length === 0"
            >({{ L('empty') }})</md-menu-item
          >
          <md-menu-item
            :class="'presetList'"
            v-for="preset in presets"
            :key="preset.name"
            @click="loadPreset(preset)"
          >
            {{ preset.name }}
          </md-menu-item>
          <!-- preset불러오기 -->
        </md-menu-content>
      </md-menu>
      <!--select Date Menu-->
      <md-menu>
        <md-button class="account-btn" md-menu-trigger>{{
          L(dateType)
        }}</md-button>
        <md-menu-content>
          <md-menu-item :class="'presetList'" @click="monthType('oneMonth')">{{
            L('oneMonth')
          }}</md-menu-item>
          <md-menu-item
            :class="'presetList'"
            @click="monthType('threeMonths')"
            >{{ L('threeMonths') }}</md-menu-item
          >
          <md-menu-item :class="'presetList'" @click="monthType('range')">{{
            L('range')
          }}</md-menu-item>
        </md-menu-content>
      </md-menu>
      <!--New Date Search Part Start-->
      <md-menu
        md-align-trigger
        md-size="small"
        v-show="useSelectBox"
        class="sub-toolbar-last-menu"
      >
        <md-button class="account-btn" md-menu-trigger>
          {{ months.join('~') }}
          <fa-icon icon="caret-down" />
        </md-button>
        <!-- 연-월 필터 -->
        <md-menu-content>
          <md-menu-item
            v-for="month in monthArray"
            :key="month"
            class="account-item"
            @click="changeMonth(month)"
            >{{ month }}</md-menu-item
          >
        </md-menu-content>
      </md-menu>
      <md-datepicker
        :md-disabled-dates="disableStrDates()"
        v-model="pickupStrMonth"
        v-show="!useSelectBox"
        :class="'datePicker'"
      ></md-datepicker>
      <md-datepicker
        :md-disabled-dates="disableEndDates()"
        v-model="pickupEndMonth"
        v-show="!useSelectBox"
        :class="'datePicker'"
      ></md-datepicker>
      <!--New Date Search Part End-->
    </project-toolbar>
    <md-content>
      <div ref="pivot" @change="pivotChanged"></div>
    </md-content>

    <!-- add dialog -->
    <md-dialog :md-active.sync="dialog.saveAs">
      <md-dialog-title>{{ L('saveAs') }}</md-dialog-title>
      <md-dialog-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-small-size-100">
            <md-field :class="`${dialog.duplicate ? 'md-invalid' : ''}`">
              <label>{{ L('name') }}</label>
              <md-input v-model="dialog.item.name" />
              <span class="md-error">{{ L('duplicate') }}</span>
            </md-field>
          </div>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="closeSaveAs()">{{
          L('cancel')
        }}</md-button>
        <md-button class="md-primary md-raised" @click="saveAs()">{{
          L('save')
        }}</md-button>
      </md-dialog-actions>
    </md-dialog>
    <!-- // 설정-추가했을때 열리는 dialog-->

    <!-- remove confirm dialog -->
    <md-dialog-confirm
      v-if="selectedPreset"
      :md-active.sync="dialog.remove"
      :md-title="L('removePreset')"
      :md-content="L('confirmRemove') + ` ${selectedPreset.name}?`"
      :md-confirm-text="L('remove')"
      :md-cancel-text="L('cancel')"
      @md-confirm="remove()"
    />
  </div>
</template>

<script>
import 'jquery-ui/themes/base/core.css'
import 'jquery-ui/themes/base/theme.css'
import 'jquery-ui/themes/base/sortable.css'
import 'jquery-ui/ui/widgets/sortable'
import 'pivottable'
import 'pivottable/dist/plotly_renderers'
import 'jquery-ui-touch-punch'
import 'file-saver'
import XLSX from 'xlsx'
import moment from 'moment'
import { mapState } from 'vuex'
import api from '@/api'
import { getDate, getUserProjectPermissions } from '@/lib/utils'
import { getExchangeRate } from '@/lib/exchangeRate'
import ProjectToolbar from './ProjectToolbar'

function getCategory(sku) {
  const dividers = ['from', 'to', 'in']

  for (let i = 0; i < dividers.length; i += 1) {
    const idx = sku.indexOf(` ${dividers[i]} `)
    if (idx !== -1) {
      return sku.substr(0, idx)
    }
  }

  return sku
}

function fillDefault(defaultValue) {
  return (value) =>
    value === null || value === undefined || value === '' ? defaultValue : value
}

const fillNA = fillDefault('N/A')

const SET_KEY = 'costPivot.preset'

export default {
  components: { ProjectToolbar },

  data: () => ({
    pivot: {},
    rendererType: 'Table',
    presets: [],
    //저장된 preset
    selectedPreset: null,
    //선택된 preset (필터)
    dialog: {
      remove: false,
      saveAs: false,
      duplicate: false,
      item: {
        name: '',
      },
    },
    rawData: [],
    // Tags Categories 스위치 체크
    isTagsShow: true,
    // 달력 선택하는 변수들
    useSelectBox: false,
    monthArray: [],
    pickupStrMonth: null,
    pickupEndMonth: null,
    months: [],
    dateType: 'oneMonth',
    // 시작일 Datepicker 조절하는 함수
    disableStrDates() {
      return (date) => {
        const from = moment(date)
        const threeMonths = moment(this.pickupEndMonth).subtract(3, 'month')
        if (this.pickupEndMonth && !this.pickupStrMonth) {
          const selectedMonth = moment(this.pickupEndMonth)
          return threeMonths.isAfter(from) || !selectedMonth.isAfter(from)
        }
        if (this.pickupEndMonth && this.pickupStrMonth) {
          return threeMonths.isAfter(from)
        }
        return false
      }
    },
    // 마감일 Datepicker 조절하는 함수
    disableEndDates() {
      return (date) => {
        const from = moment(date)
        if (this.pickupStrMonth) {
          const threeMonths = moment(this.pickupStrMonth).add(3, 'month')
          const selectedMonth = moment(this.pickupStrMonth)
          return threeMonths.isBefore(from) || !selectedMonth.isBefore(from)
        }
        return false
      }
    },
  }),

  mounted() {
    this.move()
    this.monthType(this.dateType)
    this.loadSetting()

    // DatePicker input Tag Attribute 추가 작업
    $('.datePicker').find('input').attr('disabled', 'disabled')
    $('.datePicker').find('input').eq(0).attr('placeholder', 'Start Date')
    $('.datePicker').find('input').eq(1).attr('placeholder', 'End Date')
  },

  computed: {
    ...mapState({
      curAccount: (state) => state.curAccount,
      userInfo: (state) => state.userInfo,
      exchangeRateList: (state) => state.exchangeRateList,
      displayCurrency: (state) => state.displayCurrency,
    }),

    canDownload() {
      const downloadable = [
        'Table',
        'Heatmap',
        'Row Heatmap',
        'Col Heatmap',
        'Table Barchart',
      ]
      return downloadable.includes(this.rendererType)
    },

    disabled() {
      return !this.rawData.length
    },
  },

  watch: {
    curAccount(newAccount, oldAccount) {
      if (oldAccount && newAccount !== oldAccount) this.move()
      else this.load()
    },

    months() {
      this.monthChanged()
    },

    userInfo() {
      this.loadSetting()
    },
    // 직접 입력함 시작날
    pickupStrMonth(newDate, oldDate) {
      if (!oldDate) return
      this.changeRangeMonth()
    },
    // 직접 입력함 종료날
    pickupEndMonth(newDate, oldDate) {
      if (!oldDate) return
      this.changeRangeMonth()
    },
    // Tag Categories Swich
    isTagsShow() {
      this.showTagsCategories()
    },

    displayCurrency() {
      this.move()
    },
  },

  methods: {
    loadSetting() {
      if (!this.userInfo.seq) return

      api.userSetting
        .list(this.userInfo.seq, 'costPivot.preset')
        .then((res) => {
          this.presets = res
        })
    },

    // resetPreset 추가
    resetPreset() {
      if (!this.userInfo.seq) return

      this.selectedPreset = null
      this.load()
    },

    async load(isReload = true) {
      if (!this.curAccount.id || !this.months.length) return

      const months = [this.months[0]]
      if (this.months.length === 2) {
        const from = moment(this.months[0]).add(1, 'month')
        const to = moment(this.months[1])
        while (from.isSameOrBefore(to)) {
          months.push(from.format('YYYY-MM'))
          from.add(1, 'month')
        }
      }
      await getExchangeRate(months)

      // 검색용 날짜 포맷하는 함수
      function getFormatDateFunc(strMonth, endMonth) {
        return {
          str:
            strMonth.match(/-/g).length <= 1
              ? moment(new Date(strMonth)).format('YYYY-MM-DD')
              : strMonth,
          end:
            endMonth.match(/-/g).length <= 1
              ? moment(new Date(endMonth))
                  .add(1, 'month')
                  .date(0)
                  .format('YYYY-MM-DD')
              : endMonth,
        }
      }

      const userProjectPermissions = getUserProjectPermissions(
        this.userInfo.resource,
        this.curAccount
      )
      const params = { projects: userProjectPermissions }

      switch (this.dateType) {
        case 'oneMonth':
          this.loadUsageDaily(
            api.usage.dailyByMonths(
              this.curAccount.id,
              this.months[0],
              1,
              params
            ),
            isReload
          )
          break
        case 'threeMonths':
          this.loadUsageDaily(
            api.usage.dailyByMonths(
              this.curAccount.id,
              this.months[0],
              3,
              params
            ),
            isReload
          )
          break
        default: {
          const getFormatDate = getFormatDateFunc(
            this.months[0],
            this.months[this.months.length - 1]
          )
          this.loadUsageDaily(
            api.usage.daily(
              this.curAccount.id,
              getFormatDate.str,
              getFormatDate.end,
              params
            ),
            isReload
          )
          break
        }
      }
    },
    // end-load

    loadUsageDaily(usage, isReload) {
      return usage
        .then((data) => {
          this.checkPivotData(data, isReload)
        })
        .then(() => {
          this.showTagsCategories()
        })
    },

    loadPreset(preset) {
      api.userSetting
        .get(this.userInfo.seq, SET_KEY, preset.name)
        .then(() => {
          this.selectedPreset = preset

          this.load()
        })
        .then(() => {
          this.showTagsCategories()
        })
    },

    save() {
      const params = {
        data: this.getPivotOptions(),
      }

      if (!this.userInfo.seq) return

      api.userSetting
        .list(this.userInfo.seq, 'costPivot.preset')
        .then((res) => {
          this.presets = res
        })

      api.userSetting
        .modify(
          this.userInfo.seq,
          SET_KEY,
          this.selectedPreset.name,
          params.data
        )
        .then(() => {
          this.loadSetting()
        })
    },

    openSaveAs() {
      this.dialog.saveAs = true
    },

    closeSaveAs() {
      this.dialog.saveAs = false
    },

    saveAs() {
      // preset 저장 모달창
      if (this.dialog.item.name.length > 0) {
        const params = {
          name: this.dialog.item.name,
          data: this.getPivotOptions(),
        }

        const presetNameArray = this.presets.map((x) => x.name)
        if (!presetNameArray.includes(this.dialog.item.name)) {
          this.closeSaveAs()
          api.userSetting.add(this.userInfo.seq, SET_KEY, params).then(() => {
            this.dialog.duplicate = false
            this.loadSetting()
          })
        } else {
          this.dialog.duplicate = true
        }
      }
    },

    openRemove() {
      this.dialog.remove = true
    },

    remove() {
      api.userSetting
        .remove(this.userInfo.seq, SET_KEY, this.selectedPreset.name)
        .then(() => {
          this.selectedPreset = null
          this.loadSetting()
        })
    },

    getPivotOptions() {
      const options = JSON.parse(
        JSON.stringify($(this.$refs.pivot).data('pivotUIOptions'))
      )
      return {
        rows: options.rows,
        cols: options.cols,
        vals: options.vals,
        rowOrder: options.rowOrder,
        colOrder: options.colOrder,
        aggregatorName: options.aggregatorName,
        rendererName: options.rendererName,
        exclusions: options.exclusions,
      }
    },

    createPivot(options, reload = true) {
      const pivotData = this.rawData
        .filter(
          (elem) => !(elem.cost === 0 && elem.credit === 0 && elem.usage === 0)
        )
        .map((elem) => {
          const data = {
            Invoice: elem.invoice_month,
            Project:
              this.$config.platform.id === 'gcp'
                ? elem.project_id
                : elem.project_name,
            Service: elem.service_name,
            Product: elem.sku_name,
            ProductCategory: getCategory(elem.sku_name ? elem.sku_name : ''),
            YMD: elem.usage_date,
            YM: elem.usage_date.substr(0, 7),
            D: elem.usage_date.substr(8, 9),
            Location: elem.location,
            Country: elem.country_name || 'Global',
            Region: elem.region,
            Zone: elem.zone,
            FinalCost: elem.cost + elem.credit,
            Cost: elem.cost,
            Usage: elem.usage,
            Discount: elem.credit,
          }

          if (this.$config.feature.tags) {
            if (this.$config.platform.id === 'gcp') {
              data['T:Cores'] = fillNA(elem.t_system_cores)
              data['T:MachineSpec'] = fillNA(elem.t_system_machine_spec)
              data['T:Memory'] = fillNA(elem.t_system_memory)
            }
            data['T:Application'] = fillNA(elem.t_user_application)
            data['T:Environment'] = fillNA(elem.t_user_environment)
            data['T:Name'] = fillNA(elem.t_user_name)
            data['T:Owner'] = fillNA(elem.t_user_owner)
            data['T:Phase'] = fillNA(elem.t_user_phase)
            data['T:Project'] = fillNA(elem.t_user_project)
            data['T:Revision'] = fillNA(elem.t_user_revision)
            data['T:Role'] = fillNA(elem.t_user_role)
            data['T:Server'] = fillNA(elem.t_user_server)
            data['T:Service'] = fillNA(elem.t_user_service)
            data['T:Status'] = fillNA(elem.t_user_status)
            data['T:Team'] = fillNA(elem.t_user_team)
            data['T:User'] = fillNA(elem.t_user_user)
          }
          this.$config.billing.costPivot.excludeFields.forEach((f) => {
            delete data[f]
          })
          return data
        })
      this.rawData.splice(0, this.rawData.length)
      const renderers = $.extend(
        $.pivotUtilities.renderers,
        $.pivotUtilities.plotly_renderers
      )

      const pivotAgg = []
      const pivotAttr = []
      const objKeys = Object.keys(pivotData[0])
      objKeys.forEach((item) => {
        if (
          item !== 'Cost' &&
          item !== 'Discount' &&
          item !== 'Usage' &&
          item !== 'FinalCost'
        ) {
          pivotAgg.push(item)
        } else {
          pivotAttr.push(item)
        }
      })

      const tpl = $.pivotUtilities.aggregatorTemplates

      $(this.$refs.pivot).pivotUI(
        pivotData,
        {
          renderers,
          rows: options.rows || ['Service'],
          cols: options.cols || ['Date'],
          vals: options.vals || ['FinalCost'],
          rowOrder: options.rowOrder || 'key_a_to_z',
          colOrder: options.colOrder || 'key_a_to_z',
          aggregatorName: options.aggregatorName || 'Sum',
          rendererName: options.rendererName || 'Table',
          exclusions: options.exclusions || {},
          unusedAttrsVertical: false,
          menuLimit: 2000,
          hiddenFromDragDrop: pivotAttr,
          hiddenFromAggregators: pivotAgg,
          aggregators: {
            Count: () => tpl.count()(),
            Sum: (list) => tpl.sum()(list),
            Average: (list) => tpl.average()(list),
            Minimun: (list) => tpl.min()(list),
            Maximum: (list) => tpl.max()(list),
          },
        },
        reload
      )

      $.each($('.pvtAttr'), (idx, item) => {
        if (item.innerText === 'D ▾') {
          $(item).find('.pvtTriangle').remove()
        }
        if (item.innerText.includes('T:')) {
          $(item).parent().addClass('tag-categories')
        }
      })

      this.graphType = $(this.$refs.pivot).find('.pvtRenderer').val()
    },

    download(fileType) {
      XLSX.writeFile(
        XLSX.utils.table_to_book($('.pvtTable')[0], { raw: true }),
        `Cost Pivot_${this.curAccount.name}_${this.months.join(
          '_'
        )}.${fileType}`
      )
    },

    pivotChanged() {
      this.rendererType = $(this.$refs.pivot).find('.pvtRenderer').val()
    },

    monthType(type) {
      this.dateType = type
      if (type === 'oneMonth' || type === 'threeMonths') {
        this.useSelectBox = true
        this.monthArray = getDate(type)
        this.changeMonth(this.monthArray[0])
      } else {
        this.useSelectBox = false
        this.changeRangeMonth()
      }
    },

    // 직접입력한 날짜 포맷 및 3개월차이, 최종일자 검사 함수
    changeRangeMonth() {
      if (!this.pickupEndMonth || !this.pickupStrMonth) return

      const to = moment(this.pickupStrMonth)
      const threeMonths = moment(this.pickupStrMonth).add(3, 'month')
      const from = moment(this.pickupEndMonth)

      if (
        (!from.isBefore(to) && to.isBefore(threeMonths)) ||
        from.isSame(threeMonths)
      ) {
        this.changeMonth(
          `${moment(this.pickupStrMonth).format('YYYY-MM-DD')}~${moment(
            this.pickupEndMonth
          ).format('YYYY-MM-DD')}`
        )
        this.monthArray = []
      }
    },

    changeMonth(month) {
      this.months = month.split('~')
    },

    showTagsCategories() {
      if (this.isTagsShow) {
        $('.tag-categories').addClass('show')
        $('.tag-categories').removeClass('hide')
      } else {
        $('.tag-categories').removeClass('show')
        $('.tag-categories').addClass('hide')
      }
    },

    getExchangeRate(currency, context) {
      const er = this.exchangeRateList.find(
        (e) => e.month === context.month && e.code === currency
      )
      return er ? er.send_rate : { finalCost: 0 }
    },

    checkPivotData(data, isReload) {
      if (data.length > 0) {
        const month = moment(data[0].invoice_month).format('YYYY-MM')
        this.rawData = this.convertDailyCosts(
          data,
          this.displayCurrency,
          this.getExchangeRate.bind(this),
          { month }
        )

        // createPivot할때 선택된 option 전달필요....
        this.createPivot(
          this.selectedPreset ? this.selectedPreset.data : {},
          isReload
        )
      } else {
        this.$refs.pivot.innerHTML = `
          <p style="text-align: center; margin-top: 100px">데이터가 없습니다.</p>
        `
      }
    },

    move() {
      const enabledBq = this.$config.bq.accounts.includes(this.curAccount.id)
      if (enabledBq) {
        this.$router.replace('/billing/cost_pivot/bq')
      } else {
        this.load()
      }
    },
    monthChanged() {
      const enabledBq = this.$config.bq.accounts.includes(this.curAccount.id)
      if (enabledBq) {
        this.$router.replace('/billing/cost_pivot/bq')
      } else {
        this.load(false)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.text-transform {
  text-transform: none;
}
.md-content {
  padding: 16px;
}

/* 날짜선택 Div 크기 조절*/
.datePicker {
  width: 150px;
  min-height: 0px;
  max-height: 20px;
  top: 3px;
  padding: 0;
  margin: 0;
}

// 상단 툴바 길이 조절
@media (max-width: 800px) {
  .md-toolbar.md-dense {
    min-width: 460px;
  }

  .md-checkbox {
    width: 100px;
    margin: 16px 16px 16px 0;
    display: inline-flex;
    position: relative;
  }

  .md-checkbox {
    ::v-deep .md-checkbox-label {
      height: 20px;
      padding-left: 16px;
      position: relative;
      line-height: 15px;
      width: 100%;
    }
  }
}
</style>

<style lang="scss">
@import '../../assets/scss/pivot.scss';
table {
  &.pvtTable {
    white-space: nowrap;
  }
}
.presetList div {
  min-height: 35px;
  padding: 3px 10px 3px 10px;
}

/* 날짜선택 아이콘 위치조절*/
.md-datepicker .md-date-icon {
  margin-top: -5px;
}

.datePicker .md-input {
  height: auto;
  font-size: 12px;
  line-height: 0px;
}

.md-datepicker-body-content {
  height: 250px !important;
}

.datePicker button {
  display: none;
}

// 카테고리 항목중 T: 시작된 항목 숨김
.pvtUnused .tag-categories.hide {
  display: none;
}

// 카테고리 항목중 T: 시작된 항목 보임
.pvtUnused .tag-categories.show {
  display: inline-block;
}
</style>
